import React, { useEffect, useState } from 'react';
import '../css/MyProjectsPage.css';
import { getMyProjects } from "../services/apiService";
import { useAuth } from "../utils/auth.context";
import { useProject } from '../components/ProjectProvider';
import ProjectBlock from "./page-component/ProjectBlock";
import Project from '../assets/img/project.png';
import Translate from "../components/Translate";
import {getCurrentUser} from "../services/authService";

const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};


const MyProjectsPage = () => {
    const [projectList, setProjectList] = useState([]);
    const { user } = useAuth();
    const { selectedProject, setSelectedProject } = useProject();

    useEffect(() => {
        getMyProjectsList();
    }, []);

    const getMyProjectsList = async () => {
        try {
            const data = await getMyProjects(user.data._username);
            setProjectList(data);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="my-projects-container">
            <div className="project-details">
                {selectedProject ? (
                    <ProjectBlock project={selectedProject} />
                ) : (
                    <div className="no-project">
                        <h2><Translate language={currentUser.language} text={'selectProject'}/></h2>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyProjectsPage;
